/**
 * Scripts that run on the home page
 */
(
  function (window, document, $, _, undefined) {
    $(document).ready(
      function () {
        const reasonsCol = $('.reasons-section-left'),
          video = $('.reasons-video iframe'),
          reasonPlayBtn = reasonsCol.find('.btn-reasons-play');

        // sets up a vimeo player and makes it playable on click
        function showAndPlayVideo () {
          if (video.length > 0) {
            try {
              const player = new Vimeo.Player(video);
              reasonsCol.children()
                .toggleClass('d-none');
              reasonsCol.removeClass('py-5');
              player.play()
                .catch(
                  (error) => {
                    switch (error.name) {
                      case 'PasswordError':
                        console.log('Incorrect or missing password.');
                        break;
                      case 'PrivacyError':
                        console.log('Private Video');
                        break;
                      default:
                        console.log(`Vimeo encountered a ${error.name}`);
                        break;
                    }
                  }
                );
            } catch (error) {
              console.log(error);
            }
          }
        }

        if (reasonsCol.length > 0 && video.length > 0 && reasonPlayBtn.length > 0) {
          reasonPlayBtn.on('click', (e) => {
            e.preventDefault();
            showAndPlayVideo();
          });
        }
      }
    );
  }
)(window, document, window.jQuery, window.lodash);
